import type { ResourceConfig } from "../types";

export const userConfig = {
  displayName: "用户",
  category: "user",
  permissions: {
    "read:all": {
      label: "查看所有用户",
      description: "可以查看系统中所有用户信息",
    },
    "write:all": {
      label: "管理所有用户",
      description: "可以创建、编辑、删除用户",
    },
    "read:assigned": {
      label: "查看负责学员的用户",
      description: "可以查看自己负责学员绑定的用户和未绑定学员的用户",
    },
    "write:assigned": {
      label: "绑定负责的学员",
      description: "可以把未绑定用户绑定到自己负责的学员",
    },
    "read:own": {
      label: "查看自己的用户信息",
      description: "可以查看自己的账号设置和偏好",
    },
    "write:own": {
      label: "管理自己的设置",
      description: "可以修改自己的账号设置和偏好",
    },
  },
  scopeStrategy: "byStudentAccessEdge",
  navigation: {
    path: "/users",
    label: "用户管理",
    icon: "Shield" as const,
    requiredPermissions: ["read:all", "read:assigned"] as const,
    group: "management" as const,
    order: 30,
  },
} satisfies ResourceConfig;
